import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from './AuthProvider';

function SignoutOidc() {
    const navigate = useNavigate()
    let auth = useAuth();

    useEffect(() => {
        async function signoutAsync() {
            await auth?.signoutRedirectCallback()
            navigate('/')
        }
        signoutAsync()
    }, [navigate])

    return (
        <div>
            Redirecting...
        </div>
    )
}

export default SignoutOidc
